module.exports = __webpack_public_path__ + "img/a_l5.6c2ddfbb.png";